import { ReactComponent as Person } from "../../../../assets/icons/person.svg";

export function Roles() {
    return (
        <div className="flex-1 relative bg-white pt-11 rounded-md border border-[#DEDEDE]">
      <div className="absolute top-0 left-0 w-full border border-[#DEDEDE] bg-[#B4B4B421] rounded-[7px] h-11 flex items-center px-4 text-text2 text-[17px] leading-[20.5px]">
        <Person className="w-[22px] h-[22px]" />
        Roles
      </div>
      <div className="bg-white rounded-md">
        <div className="flex flex-col gap-4 px-4 py-3">
            <div className="flex items-center justify-between text-base font-normal text-black">
                <span>Account Specialists</span>
                <span>10</span>
            </div>
            <div className="flex items-center justify-between text-base font-normal text-black">
                <span>Account Specialists</span>
                <span>10</span>
            </div>
        </div>
      </div>
    </div>
    )
}